// API client for the Tomitra backend admin endpoints.
// Admin calls authenticate ONLY with a Firebase ID token; the backend verifies
// it and checks the email allowlist. No shared secret is ever sent from the
// browser (a client-side token would be baked into the public bundle).

const BASE_URL = import.meta.env.VITE_API_URL ?? "https://tomitra-backend-187545700403.asia-south1.run.app";

export async function adminGet<T>(path: string, firebaseToken: string | null): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: {
      ...(firebaseToken ? { Authorization: `Bearer ${firebaseToken}` } : {}),
    },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`API ${res.status}: ${text || res.statusText}`);
  }
  return res.json() as Promise<T>;
}

export async function adminPost<T>(
  path: string,
  body: unknown,
  firebaseToken: string | null
): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(firebaseToken ? { Authorization: `Bearer ${firebaseToken}` } : {}),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`API ${res.status}: ${text || res.statusText}`);
  }
  return res.json() as Promise<T>;
}

export async function adminPatch<T>(
  path: string,
  body: unknown,
  firebaseToken: string | null
): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...(firebaseToken ? { Authorization: `Bearer ${firebaseToken}` } : {}),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`API ${res.status}: ${text || res.statusText}`);
  }
  return res.json() as Promise<T>;
}

export async function adminDelete<T>(path: string, firebaseToken: string | null): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    method: "DELETE",
    headers: {
      ...(firebaseToken ? { Authorization: `Bearer ${firebaseToken}` } : {}),
    },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`API ${res.status}: ${text || res.statusText}`);
  }
  return res.json() as Promise<T>;
}
